import React from 'react';
import { TableHeadersType } from '../../../../../constant/tableHeadersConstants/tableHeadersType';
import { AllUnitsMeasurementListType } from '../../../../../redux/clientSettings/clientSettingTypes';
import { TableHeader, TableLoader } from '../../../../commons';
import UnitsMeasurmentListTableData from './UnitsMeasurnmentListTableData';

type AppProps = {
  data: any[];
  headers: TableHeadersType[];
  fetching: boolean;
  handleEditUnitsMeasurmentDetails: (data: AllUnitsMeasurementListType) => void;
  isEditUnitOfMeasurementPresent?: boolean;
}

const UnitsMesurnmentListTable = ({
  data,
  headers,
  fetching,
  handleEditUnitsMeasurmentDetails,
  isEditUnitOfMeasurementPresent
}: AppProps) => {

  return (
    <>
      {fetching ? <TableLoader
        Rows={20}
        ColumnPerRow={4}
      /> :
        <div className="jobsType">
          <table className="table table-bordered thead-light">
            <thead className="text-start sticky-table-header">
              <TableHeader
                tableHeader={headers}
                extraHeader
              />
            </thead>
            <tbody>
              <UnitsMeasurmentListTableData
                tableHeaders={headers}
                data={data}
                handleEditUnitsMeasurmentDetails={handleEditUnitsMeasurmentDetails}
                isEditUnitOfMeasurementPresent={isEditUnitOfMeasurementPresent}
              />
            </tbody>
          </table>
        </div>
      }
    </>
  )
}

export default UnitsMesurnmentListTable;